(function () {
  'use strict';
  if (document.documentElement.lang.toLowerCase().split('-')[0] !== 'he') return;
  var marker = document.getElementById('gw-he-entry-20261014-v1');
  if (!marker || marker.getAttribute('data-gw-he-country') !== 'IL') return;
  var root = (marker.getAttribute('data-gw-he-root') || '').replace(/\/+$/, '');
  if (!/^\/he(?:-il)?$/i.test(root)) return;
  var key = marker.getAttribute('data-gw-he-entry');
  var tails = {
    recorder: '/pages/gladwares-ai-recorder',
    cart: '/cart',
    faq: '/pages/faqs',
    contact: '/pages/content',
    refund: '/policies/refund-policy',
    privacy: '/policies/privacy-policy',
    shipping: '/policies/shipping-policy',
    terms: '/policies/terms-of-service',
    tracking: '/apps/17TRACK',
    recorder_product: '/products/magnetic-ai-powered-voice-recorder',
    headphones: '/products/2026-noise-cancelling-wireless-headphones',
    hub: '/products/8-in-1-dual-usb-c-hub',
    folding_keyboard: '/products/folding-keyboard-with-smart-trackpad',
    air_mouse: '/products/mini-m5-dual-mode-wireless-air-mouse-keyboard'
  };
  var path = window.location.pathname.replace(/\/+$/, '').toLowerCase();
  if (!tails[key] || path !== (root + tails[key]).toLowerCase()) return;
  var images = {
  "lux-img-1-1": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-hero-mobile-v1.webp?v=1791976242",
  "lux-img-1": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-hero-desktop-v1.webp?v=1791976242",
  "P5-1": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-p5-1-v3.webp?v=1791976242",
  "P5-2": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-p5-2-v4.webp?v=1791976241",
  "P5-3": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-p5-3-v2.webp?v=1791976242",
  "P5-4": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-p5-4-v3.webp?v=1791976241",
  "P5-5": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-p5-5-v3.webp?v=1791976241",
  "P5-6": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-p5-6.webp?v=1791976242",
  "lux-img-2": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-2-v2.webp?v=1791976241",
  "lux-img-3": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-3.webp?v=1791976242",
  "lux-img-4": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-4.webp?v=1791976241",
  "lux-img-5": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-5-v2.webp?v=1791976241",
  "lux-img-6": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-6.webp?v=1791976242",
  "lux-img-7-1": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-7-1-v2.webp?v=1791976242",
  "lux-img-7-2": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-7-2.webp?v=1791976242",
  "lux-img-7-3": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-7-3.webp?v=1791976241",
  "lux-img-7-4": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-7-4.webp?v=1791976242",
  "lux-img-8-1": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-8-1.webp?v=1791976241",
  "lux-img-8-2": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-8-2.webp?v=1791976241",
  "lux-img-8-3": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-recorder-he-il-lux-img-8-3-module-fix-v2.webp?v=1792806131",
  "lux-img-8-4": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-8-4-v2.webp?v=1791976241",
  "lux-img-9-1": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-9-1-v2.webp?v=1791976242",
  "lux-img-9-2": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-ai-recorder-he-20261014-lux-img-9-2-v2.webp?v=1791976241",
  "lux-img-9-3": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-recorder-he-il-lux-img-9-3-module-fix-v2.webp?v=1792806134",
  "lux-img-9-4": "https://cdn.shopify.com/s/files/1/0091/8264/2261/files/gw-recorder-he-il-lux-img-9-4-module-fix-v2.webp?v=1792806137"
};
  var hebrew = /[\u0590-\u05ff]/;

  function setImage(img, url, hero) {
    if (!img || img.tagName !== 'IMG' || !url) return;
    img.setAttribute('src', url);
    img.setAttribute('data-src', url);
    img.setAttribute('data-srcset', url);
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    if (hero) {
      img.setAttribute('loading', 'eager');
      img.setAttribute('fetchpriority', 'high');
    }
    var picture = img.closest('picture');
    if (picture) picture.querySelectorAll('source').forEach(function (source) {
      source.setAttribute('srcset', url);
      source.setAttribute('data-srcset', url);
    });
  }

  function imagesOnce() {
    if (key !== 'recorder') return;
    Object.keys(images).forEach(function (id) {
      if (id.indexOf('lux-img-') !== 0) return;
      setImage(document.getElementById(id), images[id], id === 'lux-img-1' || id === 'lux-img-1-1');
    });
    var thumbs = document.querySelectorAll('#lux-thumb-strip .lux-thumb');
    if (thumbs.length !== 6) return;
    thumbs.forEach(function (thumb, index) {
      var url = images['P5-' + (index + 1)];
      thumb.setAttribute('data-he-image', url);
      thumb.setAttribute('data-he-il-image', url);
      setImage(thumb.querySelector('img'), url, false);
    });
    var active = document.querySelector('#lux-thumb-strip .lux-thumb.is-active') || thumbs[0];
    setImage(document.getElementById('lux-main-image'), active.getAttribute('data-he-image'), false);
  }

  function textDirection(container) {
    var nodes = Array.from(container.querySelectorAll('h1,h2,h3,h4,h5,h6,p,li,dt,dd,label,summary,button,a,span,input,textarea'));
    var changes = [];
    nodes.forEach(function (node) {
      if (node.closest('#looxReviews,[data-loox],.loox-rating')) return;
      if (node.tagName === 'INPUT' || node.tagName === 'TEXTAREA') {
        var type = (node.getAttribute('type') || 'text').toLowerCase();
        if (type === 'email' || type === 'tel' || type === 'number') {
          changes.push({node: node, attr: 'data-gw-he-input', value: 'identifier-v1'});
        } else if (hebrew.test(node.getAttribute('placeholder') || '')) {
          changes.push({node: node, attr: 'data-gw-he-input', value: 'text-v1'});
        }
        return;
      }
      var text = (node.textContent || '').trim();
      var modelName = /^(Gladwares(?:™)?|MemoryCard AI Pro(?:\s*(?:#\d+|\(×\d+\)))?|DOWAY|ULTRA NOTES|Pro\s*\(MagSafe\))$/.test(text);
      var pageflyCopy = key === 'recorder' && node.closest('[data-pf-type="Body"]') && (/^(H[1-5]|P|LI|DT|DD)$/.test(node.tagName) || (node.tagName === 'SPAN' && /[A-Za-z]/.test(text) && !modelName));
      if (!hebrew.test(node.textContent || '') && !pageflyCopy) return;
      if (/^(P|LI)$/.test(node.tagName) && /(?:^|\s)cart_(?:subtotal|savings)(?:\s|$)/.test(node.className || '')) return;
      var style = window.getComputedStyle(node);
      if (style.display.indexOf('flex') !== -1 || style.display.indexOf('grid') !== -1) return;
      changes.push({node: node, attr: 'data-gw-he-text', value: style.textAlign === 'center' ? 'center-v1' : 'right-v1'});
    });
    changes.forEach(function (change) {
      if (change.node.getAttribute(change.attr) !== change.value) change.node.setAttribute(change.attr, change.value);
    });
  }

  function localLinks() {
    var permitted = Object.keys(tails).map(function (name) { return tails[name].toLowerCase(); });
    document.querySelectorAll('header a[href],footer a[href],.footer a[href],#header a[href],.cart_content a[href],a.cart-upsell__name').forEach(function (a) {
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.origin); } catch (e) { return; }
      if (url.origin === window.location.origin) {
        var relative = url.pathname.replace(/^\/(?:[a-z]{2}(?:-[a-z]{2})?)?(?=\/)/i, '');
        if (relative.charAt(0) !== '/') relative = '/' + relative;
        if (permitted.indexOf(relative.toLowerCase()) !== -1) {
          a.setAttribute('href', root + relative + url.search + url.hash);
        }
      } else if (url.hostname === 'shopify.com' && url.pathname === '/9182642261/account/orders') {
        url.searchParams.set('locale', 'he');
        url.searchParams.set('region_country', 'IL');
        a.setAttribute('href', url.href);
      }
    });
  }

  document.addEventListener('gw-he-cart-rendered', function () {
    document.querySelectorAll('.js-cart_items,.js-cart_subtotal,.js-cart_savings').forEach(textDirection);
  });

  imagesOnce();
  textDirection(document);
  localLinks();
  var bundle = key === 'recorder' ? document.getElementById('lux-bundle-area') : null;
  if (bundle && typeof MutationObserver !== 'undefined') {
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        textDirection(bundle);
      });
    }).observe(bundle, {childList: true, subtree: true});
  }
})();
